import ErnstigeBloedingenOnderVka from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-vka.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderVka,
  ChartCollapse,
  React
};